export const GLOBAL_LOGOUT = 'jcp/GLOBAL_LOGOUT'; // eslint-disable-line
